






























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import CommonInput from "@/components/common/CommonInput.vue";
@Component({
  components: {CommonInput}
})
export default class AddLesson extends Vue {
  private title:string = '';
  private link:string = '';
  private img:string = '';

  private handleAddLesson() {
    const data = {title: this.title, videoLink: this.link};
    this.cleanData();
    this.$emit('addItem', data);
  }

  private cleanData() {
    this.title = '';
    this.link = '';
    this.img = '';
  }

}
